export default __webpack_public_path__ + "static/media/washington.6c056961.jpg";